import React, { useState, FormEvent, useEffect, JSX } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AxiosError } from 'axios';
import cep from 'cep-promise';
import { useDialog } from '@/hooks/useDialog';
import useForm from '@/hooks/useForm';
import { getBoolean, getItem, removeItem, setItem } from '@/helpers/common/localStorage';
import validators from '@/helpers/validators';
import { Auth } from '@/model/Auth';
import ChangePassword from '@/model/ChangePassword';
import Client from '@/model/Client';
import ClientBasic from '@/model/ClientBasic';
import ClientConfirmData from '@/model/ClientConfirmData';
import RecoverAccount from '@/model/RecoverAccount';
import RecoverPassword from '@/model/RecoverPassword';
import { api } from '@/services/api';
import { REACT_APP_AUTH, REACT_APP_USER, REACT_CART } from '@/utils/config';
import { updateMask as updateMaskCPF } from '@/helpers/masks/cpf';
import { updateMask as updateMaskPhone } from '@/helpers/masks/mobilePhone';
import { unmask, updateMask as updateMaskDate } from '@/helpers/masks/generalDate';
import { Buffer } from 'buffer';
import { toast } from 'react-toastify';
import { useSidebar } from '@/hooks/useSidebar';
import { SidebarProps } from '@/components/Sidebar';
import { CartEventContent } from '@/features/core/cart/components/CartEventContent';
import { useDispatch, useSelector } from 'react-redux';
import { CartEmptyContent } from '@/features/core/cart/components/CartEmptyContent';
import ClientNotification from '@/model/ClientNotification';
import { useLoading, setLoading } from '@/redux/loading/loadingSlice';
// import { setCart, useCart } from '@/redux/cart/cartSlice';
import Cart from '@/features/core/cart/components/Cart';
import { Address } from '@/model/Address';
import { updateMask as updateMaskCEP } from '@/helpers/masks/cep';
import { CheckClientDocument } from '@/model/CheckClientDocument';
import ChangeClientData from '@/model/ChangeClientData';
import { getErrorMessage } from '@/helpers/error';
import { useLoginCaller } from '@/hooks/useLoginCaller';
import ConfirmWhatsApp from '@/model/ConfirmWhatsApp';
import { PostMessageRequest } from '@/model/PostMessageRequest';
import { PostMessageRequestOrigin } from '@/model/PostMessageRequestOrigin';
import ConfirmAccount from '@/model/ConfirmAccount';
import { PostMessageResponse } from '@/model/PostMessageResponse';
import PasswordRecoveryStrategy from '@/model/PasswordRecoveryStrategy';
import { PostMessageCheckRequest } from '@/model/PostMessageCheckRequest';
import { SearchFaceByImageResponse } from '@/model/SearchFaceByImageResponse';
import { BiometricCheckErrorResponse } from '@/model/BiometricCheckErrorResponse';
import {
  FirstLogin,
  FormInputNameAddress,
  FormInputNameChangeClientData,
  FormInputNameCheckEmail,
  FormInputNameConfirmEmail,
  FormInputNameLogin,
  FormInputNameRegister,
  FormInputNameRegisterConfirm,
  ShouldShowModal,
  ShouldShowModalProps,
} from '../../types';
import { FormInputDocument } from '../../components/CallChangePasswordDocumentContent';
import { isPendingFixes } from '../../service/validateClientDataService';
import { AuthWrapperContainer } from './ui';

interface AuthWrapperProps {
  children: React.ReactNode;
  isHomepage: boolean;
}

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children, isHomepage }): JSX.Element => {
  const [notifications, setNotifications] = useState<ClientNotification[]>([]);
  const { visible, onSetVisible, onToggle, title, onChangeTitle } = useDialog();
  const { onShowSidebar } = useSidebar();
  const [shouldShowModal, setShouldShowModal] = useState<ShouldShowModal>(ShouldShowModal.LOGIN);
  const [enableLoginPassword, setEnableLoginPassword] = useState<boolean>(false);
  const [shouldShowPasswordToText, setShouldShowPasswordToText] = useState(false);
  const [shouldShowPasswordToText2, setShouldShowPasswordToText2] = useState(false);
  const [checkClientDocument, setCheckClientDocument] = useState<CheckClientDocument>();
  const [recoverAccount, setRecoverAccount] = useState<RecoverAccount>();
  const [biometricFaceRequest, setBiometricFaceRequest] = useState<PostMessageRequest>();
  const [token, setToken] = useState(undefined as unknown as string);
  const [biometricCheckFaceRequest, setBiometricCheckFaceRequest] =
    useState<PostMessageCheckRequest>();
  const [nameRecoverPassword, setNameRecoverPassword] = useState(undefined as unknown as string);
  const [showCloseButton, setShowCloseButton] = useState(true);
  const [cpfClientBiometric, setCpfClientBiometric] = useState<string>();
  const [firstLogin, setFirstLoin] = useState<FirstLogin>();
  const { caller, clearCaller } = useLoginCaller();

  const [cart, setCart] = useState<Cart>({
    events: [],
    discountCoupon: undefined,
    voucher: undefined,
    amountItens: 0,
    totalValue: 0,
    totalValueWithFee: 0,
    originalValueWithPaymentFee: 0,
    totalValueWithPaymentFee: 0,
    pdvId: undefined,
  });
  const { loading } = useSelector(useLoading);
  const location = useLocation();
  const codeRecieve = new URLSearchParams(location.search).get('code');
  if (codeRecieve && codeRecieve.trim().length > 0) {
    if (!token) {
      setToken(codeRecieve);
    }
  }

  const history = useNavigate();
  const dispatch = useDispatch();

  const loadCart = (): void => {
    const cartStorage = getItem(REACT_CART as string) as string;
    let cartVariable: Cart | undefined;

    if (cartStorage && cartStorage.length > 0) {
      cartVariable = JSON.parse(cartStorage) as Cart;
      setCart(cartVariable);
    }
  };

  const handleOnGoTo = (href: string): void => {
    history(href);
  };

  const {
    formData: formDataCheckEmail,
    formErrors: formErrorsCheckEmail,
    onChangeFormInput: onChangeFormInputCheckEmail,
    isFormValid: isFormValidCheckEmail,
    resetForm: resetFormCheckEmail,
  } = useForm({
    initialData: {
      cpf: '',
      email: '',
      phone: '',
    },
    validators: {
      cpf: [validators.required, validators.cpf],
      // email: [validators.email],
      // phone: [validators.mobilePhone],
    },
    formatters: {
      cpf: updateMaskCPF,
      phone: updateMaskPhone,
    },
  });

  const {
    formData: formDataChangePasswordDocument,
    formErrors: formErrorsChangePasswordDocument,
    onChangeFormInput: onChangeFormChangePasswordDocument,
    isFormValid: isFormValidChangePasswordDocument,
    resetForm: resetFormChangePasswordDocument,
  } = useForm({
    initialData: {
      document: '',
    },
    validators: {
      document: [validators.required, validators.cpf],
    },
    formatters: {
      document: updateMaskCPF,
    },
  });

  const {
    formData: formDataConfirmEmail,
    formErrors: formErrorsConfirmEmail,
    onChangeFormInput: onChangeFormInputConfirmEmail,
    isFormValid: isFormValidConfirmEmail,
    resetForm: resetFormConfirmEmail,
  } = useForm({
    initialData: {
      cpf: '',
      // email: '',
      // phone: '',
      confirmationCode: '',
    },
    validators: {
      cpf: [validators.required, validators.cpf],
      // email: [validators.email],
      // phone: [validators.mobilePhone],
      confirmationCode: [validators.required],
    },
    formatters: {
      cpf: updateMaskCPF,
      // phone: updateMaskPhone,
    },
  });

  const {
    formData: formDataRegister,
    formErrors: formErrorsRegister,
    setErrors: setErrorsRegister,
    onChangeFormInput: onChangeFormInputRegister,
    isFormValid: isFormValidRegister,
    resetForm: resetFormRegister,
  } = useForm({
    initialData: {
      name: '',
      document: '',
      email: '',
      // confirmationCode: '',
      phone: '',
      date: '',
      motherName: '',
      zipCode: '',
      state: '',
      city: '',
      district: '',
      street: '',
      complement: '',
      addressnumber: '',
      password: '',
      confirmPassword: '',
      terms: '',
    },
    validators: {
      name: [validators.required],
      document: [validators.required, validators.cpf],
      email: [validators.required, validators.email],
      // confirmationCode: [validators.required],
      phone: [validators.required, validators.mobilePhone],
      date: [validators.required, validators.birthday, validators.maxLength(10)],
      motherName: [validators.required],
      zipCode: [validators.required],
      state: [validators.required],
      city: [validators.required],
      district: [validators.required],
      street: [validators.required],
      password: [
        validators.required,
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
      ],
      confirmPassword: [
        validators.required,
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
      ],
      terms: [validators.required],
    },
    formatters: {
      document: updateMaskCPF,
      phone: updateMaskPhone,
      date: updateMaskDate,
      zipCode: updateMaskCEP,
    },
  });

  const {
    formData: formDataAddress,
    formErrors: formErrorsAddress,
    onChangeFormInput: onChangeFormInputAddress,
    isFormValid: isFormValidAddress,
    resetForm: resetFormAddress,
  } = useForm({
    initialData: {
      zipCode: '',
      state: '',
      city: '',
      district: '',
      street: '',
      complement: '',
      addressnumber: '',
    },
    validators: {
      zipCode: [validators.required, validators.cep],
      state: [validators.required],
      city: [validators.required],
      district: [validators.required],
      street: [validators.required],
    },
    formatters: {
      zipCode: updateMaskCEP,
    },
  });

  const showModal = ({ value, newTitle }: ShouldShowModalProps): void => {
    setShouldShowModal(value);
    onChangeTitle(newTitle);
    onSetVisible(true);
  };

  const handleOnSignUp = async (): Promise<void> => {
    onSetVisible(false);
    if (shouldShowModal !== ShouldShowModal.TERMS) {
      resetFormRegister();
    }

    showModal({
      value: ShouldShowModal.CHECK_ACCOUNT_CONTENT,
      newTitle: 'Informe seu CPF',
    });
  };

  const handleOnToggle = (): void => {
    onToggle();
    if (shouldShowModal === ShouldShowModal.TERMS) {
      handleOnSignUp();
      setTimeout(() => {
        const element = document.getElementById('termsAndConditions');
        if (element) {
          element.scrollIntoView();
        }
      }, 300);
    }
  };

  const getOsInformation = (): string => {
    const { userAgent } = window.navigator;
    let os = 'Unknown OS';

    if (userAgent.includes('Win')) {
      os = 'Windows';
    } else if (userAgent.includes('Mac')) {
      os = 'MacOS';
    } else if (userAgent.includes('Linux')) {
      os = 'Linux';
    } else if (userAgent.includes('Android')) {
      os = 'Android';
    } else if (userAgent.includes('iOS')) {
      // For iOS devices (iPhone, iPad, iPod)
      os = 'iOS';
    }
    return os;
  };

  const getBrowserInformation = (): string => {
    const { userAgent } = window.navigator;
    let browserName;

    if (userAgent.indexOf('Edg') > -1) {
      browserName = 'Microsoft Edge';
    } else if (userAgent.indexOf('Chrome') > -1) {
      browserName = 'Chrome';
    } else if (userAgent.indexOf('Firefox') > -1) {
      browserName = 'Firefox';
    } else if (userAgent.indexOf('Safari') > -1) {
      browserName = 'Safari';
    } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('Opr') > -1) {
      // Opr for newer Opera versions
      browserName = 'Opera';
    } else if (userAgent.indexOf('Trident') > -1 || userAgent.indexOf('MSIE') > -1) {
      browserName = 'Internet Explorer';
    } else {
      browserName = 'Unknown';
    }
    return browserName;
  };

  const handleOnSendConfirmEmail = async (): Promise<void> => {
    if (isFormValidCheckEmail()) {
      try {
        dispatch(setLoading(true));
        const cpf = formDataCheckEmail[FormInputNameCheckEmail.cpf];
        const { data } = await api.get<CheckClientDocument>(`/auth/old/${cpf}`);
        setCheckClientDocument(data);
        onChangeFormInputRegister(FormInputNameRegister.document)(cpf);
        setCpfClientBiometric(formDataCheckEmail[FormInputNameCheckEmail.cpf]);
        if (!data.checkFaceId) {
          resetFormCheckEmail();
          setShowCloseButton(false);
          showModal({
            value: ShouldShowModal.BIOMETRIC_FACE,
            // value: ShouldShowModal.PERSONAL_DATA,
            newTitle: '',
          });
          setTimeout(() => {
            const { protocol } = window.location;
            const { host } = window.location;
            const requestUrl = `${protocol}//${host}`;

            const key = 'd3e379e2-9574-45c8-b987-c6fb3fb58722';
            // String(REACT_BIOMETRIC_KEY),
            const payload: PostMessageRequest = {
              apiKey: key,
              personIdentification: cpf,
              company: 'Banca Do Ingresso e Eventos LTDA',
              origin: PostMessageRequestOrigin.BROWSER,
              systemOS: getOsInformation(),
              browser: getBrowserInformation(),
              requestUrl,
            };
            setBiometricFaceRequest(payload);
          }, 3000);
        } else if (data.changePassword) {
          showModal({
            value: ShouldShowModal.CONFIRM_EMAIL_FORGOT_PASSWORD,
            newTitle: '',
          });
        } else if (data.checkConfirmationCode) {
          const payload: RecoverPassword = {
            login: cpf,
          };

          const response = await api.post<RecoverAccount>('/client/email', payload);
          setRecoverAccount(response.data);
          resetFormChangePasswordDocument();
          showModal({
            value: ShouldShowModal.CONFIRM_REGISTER,
            newTitle: '',
          });
        } else {
          showModal({
            value: ShouldShowModal.PERSONAL_DATA,
            newTitle: '',
          });
          resetFormConfirmEmail();
        }
      } catch (error) {
        toast.error(getErrorMessage(error));
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const handleChangePasswordByBiometric = async (e: FormEvent): Promise<void> => {
    e.preventDefault();

    try {
      dispatch(setLoading(true));
      const { protocol } = window.location;
      const { host } = window.location;
      const requestUrl = `${protocol}//${host}`;

      const key = 'd3e379e2-9574-45c8-b987-c6fb3fb58722';
      // String(REACT_BIOMETRIC_KEY),
      const payload: PostMessageCheckRequest = {
        apiKey: key,
        company: 'Banca Do Ingresso e Eventos LTDA',
        origin: PostMessageRequestOrigin.BROWSER,
        systemOS: getOsInformation(),
        browser: getBrowserInformation(),
        requestUrl,
        keepChecking: false,
      };
      setBiometricCheckFaceRequest(payload);
      setTimeout(() => {
        showModal({
          value: ShouldShowModal.FORGOT_PASSWORD_BIOMETRIC_FACE,
          newTitle: '',
        });
      }, 300);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const login = async (cpf: string, password: string): Promise<void> => {
    const payload = Buffer.from(`${cpf}:${password}`, 'utf8').toString('base64');

    const { data } = await api.post<Auth>(
      '/auth',
      {
        grant_type: 'client_credentials',
      },
      {
        headers: {
          Authorization: `Basic ${payload}`,
        },
      },
    );
    setItem(String(REACT_APP_AUTH), data.token);
    setItem(String(REACT_APP_USER), data.user);
  };

  // const handleOnSendConfirmEmail = async (): Promise<void> => {
  //   if (!isFormValidCheckEmail()) {
  //     try {
  //       dispatch(setLoading(true));
  //       const cpf = formDataCheckEmail[FormInputNameCheckEmail.cpf];
  //       const sendEmail = formDataCheckEmail[FormInputNameCheckEmail.email].toLowerCase();
  //       const sendPhone = formDataCheckEmail[FormInputNameCheckEmail.phone];
  //       const payload: RecoverEmail = {
  //         cpf,
  //         email: sendCodeEmail ? sendEmail : undefined,
  //         phone: !sendCodeEmail ? sendPhone : undefined,
  //       };
  //       await api.post('/client/email/confirm/send', payload);
  //       onChangeFormInputConfirmEmail(FormInputNameConfirmEmail.cpf)(cpf);
  //       if (sendCodeEmail) {
  //         onChangeFormInputConfirmEmail(FormInputNameConfirmEmail.email)(sendEmail);
  //       } else {
  //         onChangeFormInputConfirmEmail(FormInputNameConfirmEmail.phone)(sendPhone);
  //       }
  //       resetFormCheckEmail();
  //       showModal({
  //         value: ShouldShowModal.CONFIRM_EMAIL,
  //         newTitle: `Confirme seu ${sendCodeEmail ? 'e-mail' : 'whatsapp'} `,
  //       });
  //     } catch (error) {
  //       toast.error(getErrorMessage(error));
  //     } finally {
  //       dispatch(setLoading(false));
  //     }
  //   }
  // };

  const handleOnConfirmEmail = async (): Promise<void> => {
    if (isFormValidConfirmEmail()) {
      try {
        dispatch(setLoading(true));
        const cpf = formDataConfirmEmail[FormInputNameConfirmEmail.cpf];
        const confirmationCode = formDataConfirmEmail[FormInputNameConfirmEmail.confirmationCode];
        const payload: ConfirmWhatsApp = {
          cpf,
          confirmCode: confirmationCode,
        };
        await api.patch('/client/confirm-whatsapp', payload);
        if (firstLogin && firstLogin.cpf && firstLogin.password) {
          await login(firstLogin.cpf, firstLogin.password);
          toast.success('Tudo certo com sua conta');
        }
        onToggle();
        // showModal({ value: ShouldShowModal.PERSONAL_DATA, newTitle: 'Crie sua conta' });
      } catch (error) {
        toast.error(getErrorMessage(error));
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const handleOnResendEmail = async (): Promise<void> => {
    if (
      formDataConfirmEmail[FormInputNameConfirmEmail.email] &&
      formDataConfirmEmail[FormInputNameConfirmEmail.email].trim().length > 0
    ) {
      try {
        dispatch(setLoading(true));
        const cpf = formDataConfirmEmail[FormInputNameConfirmEmail.cpf];
        const email = formDataConfirmEmail[FormInputNameConfirmEmail.email].toLowerCase();
        const payload: RecoverAccount = {
          cpf,
          recoveryStrategy: PasswordRecoveryStrategy.EMAIL,
          email,
        };
        await api.post('/client/email-phone/confirm/send', payload);
      } catch (error) {
        toast.error(getErrorMessage(error));
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const getClientNotifications = async (): Promise<void> => {
    const response = await api.get<ClientNotification[]>('/client/notification');
    setNotifications(response.data);
  };

  const {
    formData: formDataLogin,
    formErrors: formErrorsLogin,
    setErrors: setErrorsLogin,
    onChangeFormInput: onChangeFormInputLogin,
    isFormValid: isFormValidLogin,
    resetForm: resetFormLogin,
  } = useForm({
    initialData: {
      document: '',
      password: '',
    },
    validators: {
      document: [validators.required, validators.cpf],
      password: [
        validators.required,
        /*
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
        */
      ],
    },
    formatters: {
      document: updateMaskCPF,
    },
  });

  /*
  const {
    formData: formDataForgotPassword,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formErrors: formErrorsForgotPassword,
    setErrors: setErrorsForgotPassword,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChangeFormInput: onChangeFormInputForgotPassword,
    isFormValid: isFormValidForgotPassword,
    resetForm: resetFormForgotPassword,
  } = useForm({
    initialData: {
      document: '',
    },
    validators: {
      document: [validators.required, validators.cpf],
    },
    formatters: {
      document: updateMaskCPF,
    },
  });
  */

  const {
    formData: formDataChangePassword,
    formErrors: formErrorsChangePassword,
    setErrors: setErrorsChangePassword,
    onChangeFormInput: onChangeFormInputChangePassword,
    isFormValid: isFormValidChangePassword,
    resetForm: resetFormChangePassword,
  } = useForm({
    initialData: {
      password: '',
      confirmPassword: '',
    },
    validators: {
      password: [
        validators.required,
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
      ],
      confirmPassword: [
        validators.required,
        validators.minLength(8),
        validators.maxLength(15),
        validators.hasPasswordOnlyNumberCharacteres,
      ],
    },
  });

  const {
    formData: formDataRegisterConfirm,
    formErrors: formErrorsRegisterConfirm,
    setErrors: setErrorsRegisterConfirm,
    onChangeFormInput: onChangeFormInputRegisterConfirm,
    isFormValid: isFormValidRegisterConfirm,
    resetForm: resetFormRegisterConfirm,
  } = useForm({
    initialData: {
      code: '',
    },
    validators: {
      code: [validators.required, validators.isNumeric, validators.minLength(6)],
    },
  });

  const {
    formData: formDataChangeClientData,
    formErrors: formErrorsChangeClientData,
    onChangeFormInput: onChangeFormInputChangeClientData,
    isFormValid: isFormValidChangeClientData,
    resetForm: resetFormChangeClientData,
  } = useForm({
    initialData: {
      document: '',
      name: '',
      email: '',
      phone: '',
      date: '',
      motherName: '',
    },
    validators: {
      document: [validators.required, validators.cpf],
      name: [validators.required],
      email: [validators.required, validators.email],
      phone: [validators.required, validators.mobilePhone],
      date: [validators.required, validators.birthday, validators.maxLength(10)],
      motherName: [validators.required],
    },
    formatters: {
      document: updateMaskCPF,
      phone: updateMaskPhone,
      date: updateMaskDate,
    },
  });

  const handleOnSignIn = (): void => {
    onSetVisible(false);
    resetFormLogin();
    showModal({
      value: ShouldShowModal.LOGIN,
      newTitle: '',
    });
  };

  const handleOnLogout = (): void => {
    onSetVisible(false);
    showModal({
      value: ShouldShowModal.LOGOUT,
      newTitle: '',
    });
  };

  const handleOnChangeCEP = async (value: string): Promise<void> => {
    if (value.length === 9) {
      const cepResponse = await cep(value);
      onChangeFormInputRegister(FormInputNameRegister.state)(cepResponse.state);
      onChangeFormInputRegister(FormInputNameRegister.city)(cepResponse.city);
      onChangeFormInputRegister(FormInputNameRegister.district)(cepResponse.neighborhood);
      onChangeFormInputRegister(FormInputNameRegister.street)(cepResponse.street);
    }
  };

  const handleOnCart = (): void => {
    onShowSidebar({
      content:
        cart && cart.amountItens > 0 ? (
          <CartEventContent history={history} />
        ) : (
          <CartEmptyContent />
        ),
      title: 'Meu carrinho',
    } as SidebarProps);
  };

  const handleOnCheckCPF = async (): Promise<void> => {
    try {
      dispatch(setLoading(true));
      if (formDataLogin[FormInputNameLogin.document].length === 14) {
        const cpf = formDataLogin[FormInputNameLogin.document];
        const { data } = await api.get<CheckClientDocument>(`/auth/old/${cpf}`);
        setCheckClientDocument(data);
        if (data.completeAddress) {
          if (data.client && data.client.address) {
            onChangeFormInputAddress(FormInputNameAddress.zipCode)(data.client.address.zipCode);
            onChangeFormInputAddress(FormInputNameAddress.state)(data.client.address.state);
            onChangeFormInputAddress(FormInputNameAddress.city)(data.client.address.city);
            onChangeFormInputAddress(FormInputNameAddress.district)(data.client.address.district);
            onChangeFormInputAddress(FormInputNameAddress.street)(data.client.address.street);
            onChangeFormInputAddress(FormInputNameAddress.complement)(
              data.client.address.complement,
            );
            onChangeFormInputAddress(FormInputNameAddress.addressnumber)(
              data.client.address.number,
            );
          }
          setEnableLoginPassword(true);
          setTimeout(() => {
            document.getElementById('loginPWD')?.focus();
          }, 200);
        } else if (data.changePassword) {
          showModal({
            value: ShouldShowModal.CONFIRM_EMAIL_FORGOT_PASSWORD,
            newTitle: '',
          });
        } else if (data.checkConfirmationCode) {
          const payload: RecoverPassword = {
            login: cpf,
          };

          const response = await api.post<RecoverAccount>('/client/email', payload);
          setRecoverAccount(response.data);
          resetFormChangePasswordDocument();
          showModal({
            value: ShouldShowModal.CONFIRM_REGISTER,
            newTitle: '',
          });
        } else {
          setEnableLoginPassword(true);
          setTimeout(() => {
            document.getElementById('loginPWD')?.focus();
          }, 200);
        }
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleIsUserEmail = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    try {
      dispatch(setLoading(true));
      if (recoverAccount && recoverAccount.cpf) {
        const payload: RecoverPassword = {
          login: recoverAccount.cpf,
          strategy: recoverAccount.recoveryStrategy,
        };
        const response = await api.post<RecoverAccount>('/auth/recover-password', payload);
        if (response.data.email) {
          setRecoverAccount(response.data);
        }
        toast.success('Mensagem de recuperação de senha enviada com sucesso!');

        showModal({
          value: ShouldShowModal.CONFIRM_EMAIL_FORGOT_PASSWORD,
          newTitle: 'Esqueceu a sua senha?',
        });
      } else {
        toast.error(
          'Não foi possível enviar a mensagem de recuperação de senha enviada! Informe o dados novamente.',
        );
        showModal({
          value: ShouldShowModal.FORGOT_PASSWORD,
          newTitle: 'Esqueceu a sua senha?',
        });
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(getErrorMessage(err));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleIFrameUpdateFaceId = async (cpf: string): Promise<void> => {
    const { protocol } = window.location;
    const { host } = window.location;
    const requestUrl = `${protocol}//${host}`;
    const key = 'd3e379e2-9574-45c8-b987-c6fb3fb58722';
    const payload: PostMessageRequest = {
      apiKey: key,
      personIdentification: cpf,
      company: 'Banca Do Ingresso e Eventos LTDA',
      origin: PostMessageRequestOrigin.BROWSER,
      systemOS: getOsInformation(),
      browser: getBrowserInformation(),
      requestUrl,
    };
    setBiometricFaceRequest(payload);
  };

  const handleOnSubmit = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidLogin()) {
        dispatch(setLoading(true));
        const cpf = formDataLogin[FormInputNameLogin.document];
        setCpfClientBiometric(cpf);
        await login(
          formDataLogin[FormInputNameLogin.document],
          formDataLogin[FormInputNameLogin.password],
        );
        const pendingFixes: boolean = checkClientDocument
          ? isPendingFixes(checkClientDocument)
          : false;
        if (checkClientDocument && !checkClientDocument.checkFaceId) {
          handleIFrameUpdateFaceId(cpf);
          setTimeout(() => {
            showModal({
              value: ShouldShowModal.BIOMETRIC_FACE_CHECK,
              newTitle: '',
            });
          }, 300);
        } else if (pendingFixes) {
          onToggle();
          history('/account/fix');
        } else {
          onToggle();
          clearCaller();
        }
      }
    } catch (error) {
      const err = error as AxiosError;
      if (err.code && err.code === 'ERR_BAD_REQUEST') {
        setErrorsLogin({
          document: ['CPF ou Senha inválida'],
          password: ['CPF ou Senha inválida'],
        });
      } else {
        toast.warn('Falha ao realizar login, tentar novamente mais tarde');
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleUpdateFaceId = async (confirmAccount: ConfirmAccount): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const response = await api.post<Client>('/client/change-faceid', confirmAccount);
      if (response.status === 200) {
        onToggle();
        onSetVisible(false);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(getErrorMessage(err));
      // setErrorsForgotPassword({
      //   document: [err.message],
      // });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handlePreRegistration = async (preRegistration: ConfirmAccount): Promise<void> => {
    try {
      const payload: ConfirmAccount = {
        cpf: preRegistration.cpf,
        faceId: preRegistration.faceId,
        confidence: preRegistration.confidence,
        faceImage: preRegistration.faceImage,
      };
      const response = await api.post('/client/confirmation-account', payload);
      if (response.status === 200) {
        showModal({
          value: ShouldShowModal.PERSONAL_DATA,
          newTitle: '',
        });
        resetFormConfirmEmail();
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(getErrorMessage(err));
      // setErrorsForgotPassword({
      //   document: [err.message],
      // });
    }
  };

  const handleOnAnalysisComplete = async (data: PostMessageResponse): Promise<void> => {
    const preRegistration = {
      cpf: cpfClientBiometric as string,
      faceId: data.faceId,
      confidence: data.confidence,
      faceImage: data.imageBase64,
    };
    if (
      checkClientDocument &&
      checkClientDocument.client &&
      checkClientDocument.client.id &&
      data.imageBase64 &&
      data.faceId &&
      data.confidence
    ) {
      handleUpdateFaceId(preRegistration);
    } else {
      handlePreRegistration(preRegistration);
    }
  };

  const handleOnChangeCEPAddress = async (value: string): Promise<void> => {
    if (value.length === 9) {
      const cepResponse = await cep(value);
      onChangeFormInputAddress(FormInputNameAddress.state)(cepResponse.state);
      onChangeFormInputAddress(FormInputNameAddress.city)(cepResponse.city);
      onChangeFormInputAddress(FormInputNameAddress.district)(cepResponse.neighborhood);
      onChangeFormInputAddress(FormInputNameAddress.street)(cepResponse.street);
    }
  };

  const handleOnSaveAddress = async (): Promise<void> => {
    if (isFormValidAddress()) {
      try {
        dispatch(setLoading(true));
        const payload = {
          zipCode: formDataAddress[FormInputNameAddress.zipCode],
          state: formDataAddress[FormInputNameAddress.state],
          city: formDataAddress[FormInputNameAddress.city],
          district: formDataAddress[FormInputNameAddress.district],
          street: formDataAddress[FormInputNameAddress.street],
          complement: formDataAddress[FormInputNameAddress.complement],
          number: formDataAddress[FormInputNameAddress.addressnumber],
        } as Address;
        await api.patch('client/my-account/address', payload);
        resetFormAddress();
        if (checkClientDocument) {
          const newCheckClientDocument = {
            ...checkClientDocument,
            completeAddress: false,
          };
          setCheckClientDocument(newCheckClientDocument);
        }

        onToggle();
      } catch (error) {
        toast.error(getErrorMessage(error));
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const handleConfirmWhatsApp = async (cpf: string, cellPhone: string): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const payload: RecoverAccount = {
        cpf,
        recoveryStrategy: PasswordRecoveryStrategy.WHATSAPP,
        phone: cellPhone,
      };
      await api.post('/client/email-phone/confirm/send', payload);
      onChangeFormInputConfirmEmail(FormInputNameConfirmEmail.cpf)(cpf);
      onChangeFormInputConfirmEmail(FormInputNameConfirmEmail.phone)(cellPhone);
      showModal({
        value: ShouldShowModal.CONFIRM_EMAIL,
        newTitle: `Confirme seu whatsapp`,
      });
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleOnSubmitRegister = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidRegister()) {
        dispatch(setLoading(true));

        const dateString = unmask(formDataRegister[FormInputNameRegister.date]);
        if (!dateString) {
          const fieldName = FormInputNameRegister.date.toString();
          setErrorsRegister({
            [fieldName]: ['Data de nascimento Inválida!'],
          });
          return;
        }
        if (
          formDataRegister[FormInputNameRegister.password] !==
          formDataRegister[FormInputNameRegister.confirmPassword]
        ) {
          setErrorsRegister({
            [FormInputNameRegister.password]: ['Senhas divergentes!'],
            [FormInputNameRegister.confirmPassword]: ['Senhas divergentes!'],
          });
          return;
        }
        const date = new Date(`${dateString}T12:00:00.000Z`);

        const address = {
          zipCode: formDataRegister[FormInputNameRegister.zipCode],
          state: formDataRegister[FormInputNameRegister.state],
          city: formDataRegister[FormInputNameRegister.city],
          district: formDataRegister[FormInputNameRegister.district],
          street: formDataRegister[FormInputNameRegister.street],
          complement: formDataRegister[FormInputNameRegister.complement],
          number: formDataRegister[FormInputNameRegister.addressnumber],
        } as Address;
        const payload: ClientBasic = {
          name: formDataRegister[FormInputNameRegister.name],
          cpf: formDataRegister[FormInputNameRegister.document],
          email: formDataRegister[FormInputNameRegister.email],
          confirmationCode: formDataRegister[FormInputNameRegister.confirmationCode],
          cellPhone: formDataRegister[FormInputNameRegister.phone],
          birthDate: date,
          motherName: formDataRegister[FormInputNameRegister.motherName],
          password: formDataRegister[FormInputNameRegister.password],
          address,
          acceptedTerms: !!(
            formDataRegister[FormInputNameRegister.terms] &&
            formDataRegister[FormInputNameRegister.terms] === 'true'
          ),
        };

        const { data } = await api.post<Client>('/client', payload);
        const newFirstLogin: FirstLogin = {
          cpf: data.cpf,
          password: formDataRegister[FormInputNameRegister.password],
        };
        setFirstLoin(newFirstLogin);
        handleConfirmWhatsApp(data.cpf, formDataRegister[FormInputNameRegister.phone]);
        // await login();
        // onToggle();
      }
    } catch {
      setErrorsRegister({
        document: ['Falha ao realizar cadastro, tentar novamente mais tarde'],
      });
    } finally {
      dispatch(setLoading(false));
    }
  };
  /*
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleOnSubmitForgotPassword = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();

      if (isFormValidForgotPassword()) {
        dispatch(setLoading(true));
        setDocumentClient(formDataForgotPassword[FormInputNameRegister.document]);

        const payload: RecoverPassword = {
          login: formDataForgotPassword[FormInputNameRegister.document],
        };

        const response = await api.post<RecoverEmail>('/client/email', payload);
        if (sendCodeEmail && response.data.email) {
          setEmailRecoverPassword(response.data.email);
        } else if (response.data.phone) {
          setPhoneRecoverPassword(response.data.phone);
        }
        showModal({
          value: ShouldShowModal.CHECk_EMAIL_FORGOT_PASSWORD,
          newTitle: '',
        });

        resetFormForgotPassword();
      }
    } catch (error) {
      const err = error as AxiosError;
      setErrorsForgotPassword({
        document: [err.message],
      });
    } finally {
      dispatch(setLoading(false));
    }
  };
  */

  const handleOnChangePersonData = (): void => {
    onChangeFormInputChangeClientData(FormInputNameChangeClientData.document)(
      recoverAccount ? recoverAccount.cpf : '',
    );
    showModal({
      value: ShouldShowModal.CHANGE_CLIENT_DATA,
      newTitle: '',
    });
  };

  const handleOnSubmitChangeClientData = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidChangeClientData()) {
        dispatch(setLoading(true));
        const dateString = unmask(formDataChangeClientData[FormInputNameChangeClientData.date]);
        const date = new Date(`${dateString}T12:00:00.000Z`);
        const payload: ChangeClientData = {
          name: formDataChangeClientData[FormInputNameChangeClientData.name],
          cpf: formDataChangeClientData[FormInputNameChangeClientData.document],
          email: formDataChangeClientData[FormInputNameChangeClientData.email],
          cellPhone: formDataChangeClientData[FormInputNameChangeClientData.phone],
          birthDate: date,
          motherName: formDataChangeClientData[FormInputNameChangeClientData.motherName],
        };

        const { data } = await api.patch<Client>('/client/change', payload);
        const split = formDataChangeClientData[FormInputNameChangeClientData.email].split('@');
        const splitDot = split[1].split('.');
        const result = `${split[0].substring(0, 2)}***@${splitDot[0].substring(0, 1)}***.${
          splitDot[splitDot.length - 1]
        }`;

        const newClient = {
          ...data,
          email: result,
          phone: data.cellPhone,
        };
        if (checkClientDocument) {
          const newCheckClientDocument = {
            ...checkClientDocument,
            client: newClient,
          };
          setCheckClientDocument(newCheckClientDocument);
        } else if (recoverAccount) {
          const newCheckClientDocument: CheckClientDocument = {
            client: newClient,
            changePassword: false,
            checkConfirmationCode: false,
            completeAddress: false,
            sendCodeEmail: false,
            checkFaceId: true,
          };
          setCheckClientDocument(newCheckClientDocument);
        }
        const newRecover: RecoverAccount = {
          cpf: data.cpf,
          recoveryStrategy: recoverAccount
            ? recoverAccount?.recoveryStrategy
            : PasswordRecoveryStrategy.WHATSAPP,
          email: data.email,
          phone: data.cellPhone,
        };
        setRecoverAccount(newRecover);
        showModal({
          value: ShouldShowModal.CONFIRM_REGISTER,
          newTitle: '',
        });
        resetFormChangeClientData();
      }
    } catch (error) {
      const err = error as AxiosError;
      setErrorsRegisterConfirm({
        document: [err.message],
      });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleOnSubmitRegisterConfirm = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidRegisterConfirm()) {
        dispatch(setLoading(true));
        if (checkClientDocument && checkClientDocument.client && checkClientDocument.client.id) {
          const payload: ClientConfirmData = {
            id: checkClientDocument.client.id,
            emailConfirmationCode: formDataRegisterConfirm[FormInputNameRegisterConfirm.code],
          };
          const { data } = await api.patch<Client>('/client/confirm-data', payload);
          if (checkClientDocument) {
            const newCheckClientDocument = {
              ...checkClientDocument,
              client: data,
            };
            setCheckClientDocument(newCheckClientDocument);
          }

          showModal({ value: ShouldShowModal.LOGIN, newTitle: '' });
        }
      }
    } catch (error) {
      const err = error as AxiosError;
      setErrorsRegisterConfirm({
        document: [err.message],
      });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleOnTogglePasswordToText = (): void =>
    setShouldShowPasswordToText(!shouldShowPasswordToText);

  const handleOnTogglePasswordToText2 = (): void =>
    setShouldShowPasswordToText2(!shouldShowPasswordToText2);

  const handleGoToCallChangePassword = async (): Promise<void> => {
    dispatch(setLoading(true));
    const response = await api.get<ClientBasic>(`/client/recover-password/${token}`);
    setNameRecoverPassword(response.data.name);
    showModal({
      value: ShouldShowModal.CALL_CHANGE_PASSWORD,
      newTitle: 'Alteração de senha',
    });
    dispatch(setLoading(false));
  };

  const handleChangePassword = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    try {
      if (isFormValidChangePassword()) {
        dispatch(setLoading(true));
        if (
          formDataChangePassword[FormInputNameRegister.password] !==
          formDataChangePassword[FormInputNameRegister.confirmPassword]
        ) {
          setErrorsChangePassword({
            password: ['Senhas divergentes!'],
            confirmPassword: ['Senhas divergentes!'],
          });
          return;
        }
        const payload: ChangePassword = {
          token,
          password: formDataChangePassword[FormInputNameRegister.password],
          confirmPassword: formDataChangePassword[FormInputNameRegister.confirmPassword],
        };
        const response = await api.post<RecoverPassword>('/auth/change-password', payload);
        await login(
          response.data.login,
          formDataChangePassword[FormInputNameRegister.confirmPassword],
        );
        dispatch(setLoading(false));
        resetFormChangePassword();
        onToggle();
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleOnSubmitResendCode = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    if (checkClientDocument && checkClientDocument.client && checkClientDocument.client.id) {
      try {
        dispatch(setLoading(true));
        await api.patch(`/client/resend-code/${checkClientDocument.client.id}`);
        toast.success('Código reenviado com sucesso!');
        resetFormRegisterConfirm();
      } catch (error) {
        const err = error as AxiosError;
        setErrorsRegisterConfirm({
          code: [err.message],
        });
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const handleOnSubmitResendEmail = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    if (recoverAccount && recoverAccount.cpf) {
      try {
        dispatch(setLoading(true));
        const payload: RecoverPassword = {
          login: recoverAccount.cpf,
          strategy: recoverAccount.recoveryStrategy,
        };

        const { data } = await api.post<RecoverAccount>('/auth/recover-password', payload);
        setRecoverAccount(data);
        toast.success('Mensagem de recuperação de senha enviada com sucesso!');
      } catch (error) {
        const err = error as AxiosError;
        toast.error(getErrorMessage(err));
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const onSubmitLogout = (): void => {
    removeItem(String(REACT_APP_AUTH));
    removeItem(String(REACT_APP_USER));
    const newCart: Cart = {
      events: [],
      discountCoupon: undefined,
      voucher: undefined,
      amountItens: 0,
      totalValue: 0,
      totalValueWithFee: 0,
      originalValueWithPaymentFee: 0,
      totalValueWithPaymentFee: 0,
    };
    setItem(REACT_CART as string, JSON.stringify(newCart));
    setCart(newCart);
    history('/');
    onSetVisible(false);
  };

  const onCloseModal = (): void => {
    onSetVisible(false);
  };

  const handleOnSupportClick = (): void => {
    window.open('https://suporte.bancadoingresso.com.br/open', '_blank');
  };

  const handleChangePasswordBiometric = async (
    searchFaceByImage: SearchFaceByImageResponse[],
  ): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const response = await api.post<string>(
        '/auth/recover-password-biometric',
        searchFaceByImage,
      );
      window.location.href = response.data;
      onToggle();
    } catch (error) {
      dispatch(setLoading(false));
      const err = error as AxiosError;
      toast.error(getErrorMessage(err));
      onToggle();
      onSetVisible(false);
    }
  };

  const handleOnAnalysisCheckFaceComplete = async (
    data: SearchFaceByImageResponse[],
  ): Promise<void> => {
    handleChangePasswordBiometric(data);
  };

  const handleOnAnalysisCheckFaceError = async (
    data: BiometricCheckErrorResponse,
  ): Promise<void> => {
    toast.error(`Status: ${data.status} - Mensagem: ${data.message}`);
    showModal({
      value: ShouldShowModal.FORGOT_PASSWORD_BIOMETRIC,
      newTitle: 'Trocar Senha',
    });
  };

  const handleOnSubmitDocument = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidChangePasswordDocument()) {
        const cpf = formDataChangePasswordDocument[FormInputDocument.document];
        const payload: RecoverPassword = {
          login: cpf,
        };

        const { data } = await api.post<RecoverAccount>('/client/email', payload);
        setRecoverAccount(data);
        resetFormChangePasswordDocument();
        if (data.recoveryStrategy === PasswordRecoveryStrategy.FACE) {
          showModal({
            value: ShouldShowModal.FORGOT_PASSWORD_BIOMETRIC,
            newTitle: 'Trocar Senha',
          });
        } else {
          showModal({
            value: ShouldShowModal.CHECk_EMAIL_FORGOT_PASSWORD,
            newTitle: '',
          });
        }
      }
    } catch (error) {
      dispatch(setLoading(false));
      const err = error as AxiosError;
      toast.error(getErrorMessage(err));
    }
  };

  useEffect(() => {
    if (token && token.trim().length > 0) {
      handleGoToCallChangePassword();
    }
    const signed = getBoolean(String(REACT_APP_AUTH));
    if (signed) {
      getClientNotifications();
    }
    // eslint-disable-next-line
  }, [token]);

  useEffect(() => {
    loadCart();
  }, []);

  useEffect(() => {
    if (caller === 'checkout') {
      setShowCloseButton(false);
    } else {
      setShowCloseButton(true);
    }
  }, [caller]);

  return (
    <AuthWrapperContainer
      state={loading}
      homepage={isHomepage}
      notifications={notifications}
      onGoTo={handleOnGoTo}
      handleOnSignIn={handleOnSignIn}
      handleOnSignUp={handleOnSignUp}
      handleOnLogout={handleOnLogout}
      onSubmitLogout={onSubmitLogout}
      onCloseModal={onCloseModal}
      handleOnCart={handleOnCart}
      visibleModal={visible}
      onToggleModal={handleOnToggle}
      titleModal={title}
      shouldShowModal={shouldShowModal}
      onShouldShowModal={showModal}
      formDataCheckEmail={formDataCheckEmail}
      formErrorsCheckEmail={formErrorsCheckEmail}
      onChangeFormCheckEmail={onChangeFormInputCheckEmail}
      onSendConfirmEmail={handleOnSendConfirmEmail}
      formDataConfirmEmail={formDataConfirmEmail}
      formErrorsConfirmEmail={formErrorsConfirmEmail}
      onChangeFormConfirmEmail={onChangeFormInputConfirmEmail}
      onConfirmEmail={handleOnConfirmEmail}
      onResendEmail={handleOnResendEmail}
      shouldShowPasswordToText={shouldShowPasswordToText}
      shouldShowPasswordToText2={shouldShowPasswordToText2}
      onTogglePasswordToText={handleOnTogglePasswordToText}
      onTogglePasswordToText2={handleOnTogglePasswordToText2}
      formDataLogin={formDataLogin}
      formErrorsLogin={formErrorsLogin}
      onChangeFormInputLogin={onChangeFormInputLogin}
      enableLoginPassword={enableLoginPassword}
      onCheckCPF={handleOnCheckCPF}
      onSubmitLogin={handleOnSubmit}
      checkClientDocument={checkClientDocument}
      recoverAccount={recoverAccount}
      biometricFaceRequest={biometricFaceRequest}
      onAnalysisComplete={handleOnAnalysisComplete}
      formDataAddress={formDataAddress}
      formErrorsAddress={formErrorsAddress}
      onChangeFormInputAddress={onChangeFormInputAddress}
      onChangeCEPAddress={handleOnChangeCEPAddress}
      onSaveAddress={handleOnSaveAddress}
      formDataRegister={formDataRegister}
      formErrorsRegister={formErrorsRegister}
      onChangeFormInputRegister={onChangeFormInputRegister}
      onChangeCEP={handleOnChangeCEP}
      onSubmitRegister={handleOnSubmitRegister}
      // formDataForgotPassword={formDataForgotPassword}
      // formErrorsForgotPassword={formErrorsForgotPassword}
      // onChangeFormInputForgotPassword={onChangeFormInputForgotPassword}
      onSubmitForgotPassword={handleChangePasswordByBiometric}
      onSubmitChangeClientData={handleOnSubmitChangeClientData}
      formDataChangeClientData={formDataChangeClientData}
      formErrorsChangeClientData={formErrorsChangeClientData}
      onChangeFormInputChangeClientData={onChangeFormInputChangeClientData}
      biometricCheckFaceRequest={biometricCheckFaceRequest}
      onAnalysisCheckFaceComplete={handleOnAnalysisCheckFaceComplete}
      onAnalysisCheckFaceError={handleOnAnalysisCheckFaceError}
      formDataChangePassword={formDataChangePassword}
      formErrorsChangePassword={formErrorsChangePassword}
      onChangeFormInputChangePassword={onChangeFormInputChangePassword}
      onSubmitChangePassword={handleChangePassword}
      formDataRegisterConfirm={formDataRegisterConfirm}
      formErrorsRegisterConfirm={formErrorsRegisterConfirm}
      onChangeFormInputRegisterConfirm={onChangeFormInputRegisterConfirm}
      onSubmitRegisterConfirm={handleOnSubmitRegisterConfirm}
      name={nameRecoverPassword}
      onSubmitResendCode={handleOnSubmitResendCode}
      onSubmitResendEmail={handleOnSubmitResendEmail}
      onChangePersonData={handleOnChangePersonData}
      onSupportClick={handleOnSupportClick}
      isUserEmail={handleIsUserEmail}
      showCloseButton={showCloseButton}
      formDataChangePasswordDocument={formDataChangePasswordDocument}
      formErrorsChangePasswordDocument={formErrorsChangePasswordDocument}
      onChangeFormChangePasswordDocument={onChangeFormChangePasswordDocument}
      onSubmitDocument={handleOnSubmitDocument}
    >
      {children}
    </AuthWrapperContainer>
  );
};
